import { render, staticRenderFns } from "./addabout.vue?vue&type=template&id=0e1b5168&scoped=true"
import script from "./addabout.vue?vue&type=script&lang=js"
export * from "./addabout.vue?vue&type=script&lang=js"
import style0 from "./addabout.vue?vue&type=style&index=0&id=0e1b5168&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b5168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1b5168')) {
      api.createRecord('0e1b5168', component.options)
    } else {
      api.reload('0e1b5168', component.options)
    }
    module.hot.accept("./addabout.vue?vue&type=template&id=0e1b5168&scoped=true", function () {
      api.rerender('0e1b5168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/addabout.vue"
export default component.exports